// Axios can automatically transform object to FormData
export const multipartFormData = <Body>(body: Body): FormData => {
  return body as FormData;
};
